<template>
  <v-container fluid>
    <v-row>
      <v-col class="col-12">
        <h1>
          <span v-if="!confirmedSurveys && !archivedSurveys">All Current Surveys</span>
          <span v-if="confirmedSurveys">Confirmed Surveys</span>
          <span v-if="archivedSurveys">Archived Surveys</span>
          <v-btn @click="confirmedSurveys = true" class="float-right" v-if="!confirmedSurveys && !archivedSurveys">Show Confirmed Surveys</v-btn>
          <v-btn @click="archivedSurveys = true" class="float-right" v-if="!confirmedSurveys && !archivedSurveys">Show Archived Surveys</v-btn>
          <v-btn @click="confirmedSurveys = false, archivedSurveys = false" class="float-right" v-if="confirmedSurveys || archivedSurveys">Show All Current Surveys</v-btn>
        </h1>
        <v-simple-table
            fixed-header
            height="450px"
        >
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">Customer</th>
              <th class="text-left">Surveyor</th>
              <th class="text-left">Address</th>
              <th class="text-left">Requested by</th>
              <th class="text-left">Date</th>
              <th class="text-left">Confirmed</th>
              <th class="text-left">Archived</th>
              <th class="text-left">Completed</th>
              <th class="text-left" style="width:320px">Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(survey, index) in surveys"
                :key="index"
            >
              <td>{{ survey.customer  }}</td>
              <td>{{ survey.surveyor }}</td>
              <td>{{ survey.address }}</td>
              <td>{{ survey.requestor }}</td>
              <td>{{ survey.date | prettyDate }}</td>
              <td>
                <v-checkbox
                    @click="updateConfirmed(index)"
                    v-model="survey.confirmed"></v-checkbox>
              </td>
              <td>
                <v-checkbox
                    @click="updateArchived(index)"
                    v-model="survey.archived"></v-checkbox>
              </td>
              <td>
                <span v-if="survey.completed === 0 || survey.completed === false">
                  No
                </span>
                <span v-else>
                  Yes
                </span>
              </td>
              <td class="pr-0">
                <router-link custom v-slot="{ navigate }" :to="`/surveys/view/${survey.id}`">
                  <v-btn
                      title="View"
                      x-small
                      @click="navigate"
                      @keypress.enter="navigate"
                      role="link">
                    Internal View
                  </v-btn>
                </router-link>
                &nbsp;
                <router-link custom v-slot="{ navigate }" :to="`/surveys/print-view/${survey.id}`">
                  <v-btn
                      title="View"
                      x-small
                      @click="navigate"
                      @keypress.enter="navigate"
                      role="link">
                    Customer View
                  </v-btn>
                </router-link>
                &nbsp;
                <router-link custom v-slot="{ navigate }" :to="`/surveys/edit/${survey.id}`">
                  <v-btn
                      title="Edit"
                      x-small
                      @click="navigate"
                      @keypress.enter="navigate"
                      role="link">
                    Edit
                  </v-btn>
                </router-link>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-pagination
            class="pt-4"
            v-model="page"
            :length="length"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            :total-visible="totalVisible"
        ></v-pagination>
      </v-col>
    </v-row>
    <v-row class="no-print">
      <v-col>
        <download-csv
            name="surveys.csv"
            :data="surveys"
            :fields="exportFields">
          <v-btn>Export</v-btn>
        </download-csv>
      </v-col>
    </v-row>
    <router-view></router-view>
  </v-container>
</template>

<script>
import axios from '../../axios';

export default {
  name: 'SurveysIndex',
  computed: {
    token() {
      return this.$store.state.token;
    },
    userid() {
      return this.$store.state.userid;
    },
  },
  data() {
    return {
      archivedSurveys: false,
      confirmedSurveys: false,
      exportFields: [
          'customer',
          'surveyor',
          'address',
          'prettyDate',
      ],
      surveys: [],
      page: 1,
      length: 0,
      totalVisible: 9,
    };
  },
  watch: {
    page() {
      this.getSurveys();
    },
    confirmedSurveys() {
      this.getSurveys();
    },
    archivedSurveys() {
      this.getSurveys();
    },
  },
  methods: {
    getSurveys() {
      axios.get(`/siteSurveys/getAll/${this.page}/${this.confirmedSurveys}/${this.archivedSurveys}.json?token=${this.token}`)
          .then((response) => {
            this.surveys = response.data.surveys;
            this.length = response.data.length;
            this.total = response.data.total;
          })
          .catch((error) => {
            console.log(error);
          });
    },
    updateConfirmed(index) {
      const survey = this.surveys[index];
      axios.get(`/siteSurveys/toggleConfirmed/${survey.id}.json?token=${this.token}`)
          .catch((error) => {
            console.log(error);
          });
    },
    updateArchived(index) {
      const survey = this.surveys[index];
      axios.get(`/siteSurveys/toggleArchived/${survey.id}.json?token=${this.token}`)
          .then(() => {
            this.surveys.splice(index, 1);
          })
          .catch((error) => {
            console.log(error);
          });
    },
  },
  mounted() {
    this.getSurveys();
  },
};
</script>
